import { render, staticRenderFns } from "./inicio_es.vue?vue&type=template&id=41bbbd14&"
import script from "./inicio_es.vue?vue&type=script&lang=js&"
export * from "./inicio_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports